import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHeadphones: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHeadphones"><Path d="M5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12V13H15V21H21V12C21 7.36745 17.5 3.55237 13 3.05493V3H12C7.02944 3 3 7.02944 3 12V21H9V13H5V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHeadphones;
